/*
 * Lazy load
 * http://www.appelsiini.net/projects/lazyload
 */
$(document).ready(function() {
  $(".lazy").lazyload({ effect : "fadeIn" });
});

/*
 * Scroll to
 */
$(document).ready(function() {
  $('a.scrollTo').click(function() {
    var elementClicked = $(this).attr("href");
    var destination = $(elementClicked).offset().top;
    $("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination-70}, 500 );
    return false;
  });
});

/*
 * Volume video home page
 */
$(document).ready(function(){
  $(".video-stop-volume").prop("volume", 0);
});

/*
 * Animated link
 */
$(document).ready(function(){

    $('.h-pulse').hover(
        function() {
            $( this ).addClass('animated pulse');
        }, function() {
            $( this ).removeClass('animated pulse');
        }
    );

    $('.h-rubberband').hover(
        function() {
            $( this ).addClass('animated rubberBand');
        }, function() {
            $( this ).removeClass('animated rubberBand');
        }
    );

    $('.h-tada').hover(
        function() {
            $( this ).addClass('animated tada');
        }, function() {
            $( this ).removeClass('animated tada');
        }
    );
});